export default __webpack_public_path__ + "static/media/happy_ending.dd9111e7.mp3";